
const icons = [
    '', 'xitonggongju', 'pingtaiguanli', 'shezhi1', 'notification', 'exit-full-screen', 'full-screen',
    'daimashengcheng', 'yonghuguanli', 'shujuyuan', 'jiekouwendang', 'zaixiankaifa',
    'xitongjiankong', 'caidanguanli', 'quanxianguanli', 'qunzuguanli', 'jiaoseguanli',
    'xitongshezhi', 'kaifa', 'danjusvg3', 'danjusvg4', 'danjusvg2', 'danjusvg1',
    'gengduo', 'jiahao', 'zhutishezhi', 'guojihua', 'tuozhuai', 'menu-unfold',
    'menu-fold', 'pdf', 'WORD', 'PPT', 'PDF', 'excel1', 'user-girl', 'user-boy',
    'shangchuan', 'fachuan', 'xinnengyuan', 'tuzhuang', 'chongya', 'hanzhuang',
    'zongzhuang', 'zhongzhi', 'chexiao', 'quxiao', 'tongbu', 'fasong', 'riqi',
    'queding', 'dayin', 'chaxun', 'shouquan', 'shengji', 'zhuanfa', 'yinru',
    'shangyibu', 'bianji', 'yichu', 'chakan', 'bohui', 'zhengque', 'shanchu',
    'shuaxin', 'cuowu', 'baocunbingguanbi', 'xiayibu', 'liucheng', 'fuzhi',
    'quanping-huanyuan', 'fabu', 'daoru', 'youjian', 'lianjie', 'baocun',
    'zuidahua-huanyuan', 'daochu', 'xiazai', 'zuidahua', 'banben', 'fujian',
    'jiancha', 'guanbi', 'shijian', 'fenpei', 'xiaoxi', 'zhou', 'shezhi', 'quanping',
    'xinjian', 'duibi', 'gonggao'
];

export default icons



// WEBPACK FOOTER //
// ./src/components/IconSelect/requireIcons.js